import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { AppRoutes } from "./app.routes";
import { AppComponent } from "./app.component";
import { LoginModule } from "./login/login.module";
import { CoreModule } from "./core/core.module";
import { HomeModule } from "./home/home.module";
import { AuthService } from "./core/security/auth.service";
import { BlockUIModule, GrowlModule } from "primeng/primeng";
import {
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatProgressSpinnerModule
} from "@angular/material";
import { StoreModule } from "@ngrx/store";
import { reducers } from "./reducers";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { EffectsModule } from "@ngrx/effects";
import { HttpClientModule } from "@angular/common/http";
import { StompConfig, StompService } from "@stomp/ng2-stompjs";
import * as SockJS from "sockjs-client";
import { environment } from "../environments/environment";
import { LibraryModule } from "./library/library.module";
import { ProfileService } from "./profile/service/profile.service";
import { ProfileStoreService } from "./profile/service/profile-store.service";

export function socketProvider() {
  return new SockJS(environment.webSocketHost);
}

const stompConfig: StompConfig = {
  // Which server?
  url: socketProvider,

  // Headers
  // Typical keys: login, passcode, host
  headers: {
    login: "guest",
    passcode: "guest"
  },

  // How often to heartbeat?
  // Interval in milliseconds, set to 0 to disable
  heartbeat_in: 0, // Typical value 0 - disabled
  heartbeat_out: 20000, // Typical value 20000 - every 20 seconds

  // Wait in milliseconds before attempting auto reconnect
  // Set to 0 to disable
  // Typical value 5000 (5 seconds)
  reconnect_delay: 5000,

  // Will log diagnostics on console
  debug: false
};

@NgModule({
  imports: [
    // HttpModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CoreModule,
    LoginModule,
    HomeModule,
    LibraryModule,
    AppRoutes,
    GrowlModule,
    BlockUIModule,
    MatProgressSpinnerModule,
    MatNativeDateModule,
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25
    }),
    EffectsModule.forRoot([])
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    StompService,
    ProfileService,
    {
      provide: StompConfig,
      useValue: stompConfig
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MAT_DATE_LOCALE, useValue: "es-AR" },
    AuthService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts